import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import Masthead from '../../components/Masthead';
import { getUrlHostname } from '../../utils/url';
import { addCommas } from '../../utils/strings';
import withHostContext, {
  trackingLocations,
  trackClickTypes,
  trackView,
} from '../../context/host/consumer';

class MastheadContainer extends React.Component {
  static propTypes = {
    scid: PropTypes.number,
    collegeData: PropTypes.object,
    userData: PropTypes.object,
    collegeContact: PropTypes.array,
    sendEmail: PropTypes.func,
    isFavorite: PropTypes.bool,
    isApplyingTo: PropTypes.bool,
    toggleFavorite: PropTypes.func,
    collapsed: PropTypes.bool,
  };

  handleCollegeUrlClick = (e) => {
    if (
      get(e, 'target.href', null) &&
      e.target.getAttribute('data-click-location') === trackingLocations.MASTHEAD_URL
    ) {
      trackView(this.props.hostContext, {
        type: trackClickTypes.HUBS_VIEW,
        location: trackingLocations.MASTHEAD_URL,
      });
    }
  };

  render() {
    const { collegeData, scid, hostContext, ...rest } = this.props;

    const url = get(collegeData, 'fullProfile.overview.website.value', '');
    const state = get(
      collegeData,
      'fullProfile.overview.admissionsOffice.state.value',
      '-',
    );
    const city = get(collegeData, 'fullProfile.overview.city.value', '');
    const country = get(
      collegeData,
      'fullProfile.overview.admissionsOffice.country.value',
      '',
    );
    const ceebCode = get(collegeData, 'fullProfile.overview.navianceId.value', '');
    const admissionsOffice = get(collegeData, 'fullProfile.overview.admissionsOffice');
    const isCamino = get(hostContext, 'isCamino', false);
    const coedStatus =
      isCamino && get(collegeData, 'fullProfile.studentLife.coedStatus.value');
    const headerMessage = isCamino && get(hostContext, 'headerMessage');
    const schoolLevel =
      isCamino && get(collegeData, 'fullProfile.overview.schoolType.level.value', '');
    const schoolType =
      isCamino && get(collegeData, 'fullProfile.overview.schoolType.control.value', '');

    return (
      <Masthead
        hubsWebLinks={get(collegeData, 'webLink', {})}
        virtualTour={get(collegeData, 'virtualTour', false) || ''}
        schoolName={get(collegeData, 'fullProfile.overview.schoolName.value', '')}
        scid={scid}
        address={addCommas([city, state, country])}
        url={url}
        urlText={url && getUrlHostname(url)}
        ceebCode={ceebCode}
        admissionsOffice={admissionsOffice}
        handleCollegeUrlClick={this.handleCollegeUrlClick}
        coedStatus={coedStatus}
        headerMessage={headerMessage}
        schoolLevel={schoolLevel}
        schoolType={schoolType}
        {...rest}
      />
    );
  }
}

export default withHostContext(MastheadContainer);
